
import { faEye, faEyeSlash } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'FieldPassword',

  props: {
    value: {
      type: String,
      default: ''
    },

    name: {
      type: String,
      default: ''
    },

    label: {
      type: String,
      default: undefined
    },

    rules: {
      type: Object,
      default: () => ({})
    },

    autocomplete: {
      type: String,
      default: 'Password'
    }
  },

  data() {
    return {
      isPasswordVisible: false,
      faEye,
      faEyeSlash
    }
  },

  computed: {
    compValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    compPasswordVisibilityLabel() {
      return this.isPasswordVisible ? this.$t('hide') : this.$t('show')
    },

    compPasswordFieldType() {
      return this.isPasswordVisible ? 'text' : 'password'
    }
  },

  methods: {
    togglePasswordVisibility() {
      this.$log.debug('Clicked to reveal password')

      this.isPasswordVisible = !this.isPasswordVisible
    }
  }
}
